import { z } from 'zod'

export const zSetting = (value: z.ZodTypeAny) => {
  return z.object({
    id: z.number().nullable(),
    field: z.string(),
    value,
  })
}
